
import {
  AvatarQuality,
  VoiceChatTransport,
  VoiceEmotion,
  STTProvider,
  ElevenLabsModel,
} from "@heygen/streaming-avatar";

export const AVATARS = [
  {
    avatar_id: "Elenora_IT_Sitting_public",
    name: "Elenora Tech Expert",
  },
  {
    avatar_id: "Wayne_20240711",
    name: "Wayne Language Expert",
  },
];

export const DEFAULT_CONFIG = {
  quality: AvatarQuality.Low,
  avatarName: AVATARS[1].avatar_id, // Wayne Language Expert (male, default)
  knowledgeId: undefined,
  voice: {
    rate: 1.0, // Slower rate for Wayne - might help with stability
    emotion: VoiceEmotion.EXCITED,
    model: ElevenLabsModel.eleven_flash_v2_5,
  },
  language: "en",
  voiceChatTransport: VoiceChatTransport.WEBSOCKET,
  sttSettings: {
    provider: STTProvider.DEEPGRAM,
  },
};

export const STT_LANGUAGE_LIST = [
  { label: "Bulgarian", value: "bg", key: "bg" },
  { label: "Chinese", value: "zh", key: "zh" },
  { label: "Czech", value: "cs", key: "cs" },
  { label: "Danish", value: "da", key: "da" },
  { label: "Dutch", value: "nl", key: "nl" },
  { label: "English", value: "en", key: "en" },
  { label: "Finnish", value: "fi", key: "fi" },
  { label: "French", value: "fr", key: "fr" },
  { label: "German", value: "de", key: "de" },
  { label: "Greek", value: "el", key: "el" },
  { label: "Hindi", value: "hi", key: "hi" },
  { label: "Hungarian", value: "hu", key: "hu" },
  { label: "Indonesian", value: "id", key: "id" },
  { label: "Italian", value: "it", key: "it" },
  { label: "Japanese", value: "ja", key: "ja" },
  { label: "Korean", value: "ko", key: "ko" },
  { label: "Malay", value: "ms", key: "ms" },
  { label: "Norwegian", value: "no", key: "no" },
  { label: "Polish", value: "pl", key: "pl" },
  { label: "Portuguese", value: "pt", key: "pt" },
  { label: "Romanian", value: "ro", key: "ro" },
  { label: "Russian", value: "ru", key: "ru" },
  { label: "Slovak", value: "sk", key: "sk" },
  { label: "Spanish", value: "es", key: "es" },
  { label: "Swedish", value: "sv", key: "sv" },
  { label: "Turkish", value: "tr", key: "tr" },
  { label: "Ukrainian", value: "uk", key: "uk" },
  { label: "Vietnamese", value: "vi", key: "vi" },
]; 

// import {
//   AvatarQuality,
//   VoiceChatTransport,
//   VoiceEmotion,
//   STTProvider,
//   ElevenLabsModel,
// } from "@heygen/streaming-avatar";

// export const AVATARS = [
//   {
//     avatar_id: "Ann_Therapist_public",
//     name: "Ann Therapist",
//   },
//   {
//     avatar_id: "Shawn_Therapist_public",
//     name: "Shawn Therapist",
//   },
//   {
//     avatar_id: "Bryan_FitnessCoach_public",
//     name: "Bryan Fitness Coach",
//   },
//   {
//     avatar_id: "Dexter_Doctor_Standing2_public",
//     name: "Dexter Doctor Standing",
//   },
//   {
//     avatar_id: "Elenora_IT_Sitting_public",
//     name: "Elenora Tech Expert",
//   },
//   {
//     avatar_id: "Wayne_20240711",
//     name: "Wayne Language Expert",
//   },
  
// ];

// export const DEFAULT_CONFIG = {
//   quality: AvatarQuality.Low,
//   avatarName: AVATARS[5].avatar_id, // Wayne Language Expert
//   knowledgeId: undefined,
//   voice: {
//     rate: 1.0, // Slower rate for Wayne - might help with stability
//     emotion: VoiceEmotion.EXCITED,
//     model: ElevenLabsModel.eleven_flash_v2_5,
//   },
//   language: "en",
//   voiceChatTransport: VoiceChatTransport.WEBSOCKET,
//   sttSettings: {
//     provider: STTProvider.DEEPGRAM,
//   },
// };

// export const STT_LANGUAGE_LIST = [
//   { label: "Bulgarian", value: "bg", key: "bg" },
//   { label: "Chinese", value: "zh", key: "zh" },
//   { label: "Czech", value: "cs", key: "cs" },
//   { label: "Danish", value: "da", key: "da" },
//   { label: "Dutch", value: "nl", key: "nl" },
//   { label: "English", value: "en", key: "en" },
//   { label: "Finnish", value: "fi", key: "fi" },
//   { label: "French", value: "fr", key: "fr" },
//   { label: "German", value: "de", key: "de" },
//   { label: "Greek", value: "el", key: "el" },
//   { label: "Hindi", value: "hi", key: "hi" },
//   { label: "Hungarian", value: "hu", key: "hu" },
//   { label: "Indonesian", value: "id", key: "id" },
//   { label: "Italian", value: "it", key: "it" },
//   { label: "Japanese", value: "ja", key: "ja" },
//   { label: "Korean", value: "ko", key: "ko" },
//   { label: "Malay", value: "ms", key: "ms" },
//   { label: "Norwegian", value: "no", key: "no" },
//   { label: "Polish", value: "pl", key: "pl" },
//   { label: "Portuguese", value: "pt", key: "pt" },
//   { label: "Romanian", value: "ro", key: "ro" },
//   { label: "Russian", value: "ru", key: "ru" },
//   { label: "Slovak", value: "sk", key: "sk" },
//   { label: "Spanish", value: "es", key: "es" },
//   { label: "Swedish", value: "sv", key: "sv" },
//   { label: "Turkish", value: "tr", key: "tr" },
//   { label: "Ukrainian", value: "uk", key: "uk" },
//   { label: "Vietnamese", value: "vi", key: "vi" },
// ]; 